/* eslint-disable no-unused-vars */
import React from "react";

export const ToastContext = React.createContext({
  show: (color, text) => {},
});

const useToast = () => React.useContext(ToastContext);

export default useToast;
